// extracted by mini-css-extract-plugin
export default {"sideBar":"SpreadsheetTemplate_sideBar__JsYhP","mainContent":"SpreadsheetTemplate_mainContent__bdyCZ","subTitle":"SpreadsheetTemplate_subTitle__3nFPy"};